import {
    allFetch
} from "../Domain";

/**
 * @description 客戶
 */
export const Customer = (() => {
    /**
     * @description 車主新增(MOS用)
     */
    const CustomerCreateFromExcel = async function (obj = {
        customer_name: '',
        customer_phone: ''
    }) {
        return await allFetch('Customer/CustomerCreateFromExcel', obj);
    }

    /**
     * @description 車主修改(MOS用)
     */
    const CustomerUpdateFromExcel = async function (obj = {
        customer_id: '',
        customer_name: '',
        customer_phone: ''
    }) {
        return await allFetch('Customer/CustomerUpdateFromExcel', obj);
    }

    /**
     * @description 車主修改
     */
    const CustomerUpdate = async function (obj = {
        customer_id: '',
        customer_name: '',
        customer_phone: '',
        city: '',
        area: '',
        customer_email: '',
        customer_address: ''
    }) {
        return await allFetch('Customer/CustomerUpdate', obj);
    }
    /**
     * @description 車主查詢
     */
    const CustomerSearch = async function (obj = {
        customer_name: '',
        customer_phone: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('Customer/CustomerSearch', obj);
    }

    /**
     * @description 車主細項
     */
    const CustomerDetail = async function (obj = {
        customer_id: ''
    }) {
        return await allFetch('Customer/CustomerDetail', obj);
    }

    /**
     * @description 車主新建
     */
    const CustomerCreate = async function (obj = {
        customer_name: '',
        customer_phone: '',
        city: '',
        area: '',
        customer_email: '',
        customer_address: ''
    }) {
        return await allFetch('Customer/CustomerCreate', obj);
    }

    return {
        CustomerCreateFromExcel,
        CustomerUpdateFromExcel,
        CustomerSearch,
        CustomerDetail,
        CustomerCreate,
        CustomerUpdate
    }
})();